import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { StoreProvider } from "@/context/StoreContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetails from "@/pages/ProductDetails";
import CartPage from "@/pages/CartPage";
import Checkout from "@/pages/Checkout";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Wishlist from "@/pages/Wishlist";
import Auth from "@/pages/Auth";
import Account from "@/pages/Account";
import Admin from "@/pages/admin/AdminDashboard";
import TrackOrder from "@/pages/TrackOrder";
import { About, Contact, FAQ, Policy } from "@/pages/Static";

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <AuthProvider>
        <StoreProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/shop" element={<Shop />} />
                    <Route path="/product/:slug" element={<ProductDetails />} />
                    <Route path="/cart" element={<CartPage />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/checkout/success" element={<CheckoutSuccess />} />
                    <Route path="/wishlist" element={<Wishlist />} />
                    <Route path="/login" element={<Auth />} />
                    <Route path="/account" element={<Account />} />
                    <Route path="/track-order" element={<TrackOrder />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/privacy" element={<Policy title="Privacy Policy" body={["GULIT respects your privacy. We collect only the information necessary to process your orders and improve your experience.", "We never sell your personal data. Payment information is processed securely by Stripe and never stored on our servers.", "You may request deletion of your account and data at any time by contacting us."]} />} />
                    <Route path="/shipping" element={<Policy title="Shipping Policy" body={["We ship worldwide via USPS, UPS, FedEx and DHL. Orders over $75 qualify for free standard shipping.", "Most orders are dispatched within 1–2 business days. Delivery times vary by destination, typically 3–7 business days.", "You will receive a tracking number to follow your order every step of the way."]} />} />
                    <Route path="/returns" element={<Policy title="Return Policy" body={["We offer 30-day hassle-free returns on all items in original, unused condition.", "To start a return, contact our team with your order number. Refunds are processed within 5–7 business days of receiving your return.", "Personalized and print-on-demand items may not be eligible for return unless defective."]} />} />
                    <Route path="/terms" element={<Policy title="Terms & Conditions" body={["By using GULIT, you agree to our terms of service. All content and trademarks belong to GULIT.", "Prices and availability are subject to change. We reserve the right to refuse service.", "These terms are governed by applicable consumer protection laws."]} />} />
                  </Routes>
                </Layout>
              } />
            </Routes>
            <Toaster position="bottom-right" />
          </BrowserRouter>
        </StoreProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
